angular.module('ui.order.orderItemsGridSharedSettings', [])

    // Shared settings for order item grid and order item list
    .service('orderItemsGridSharedSettings', function () {

        // todo: comments for getters/setters
        // todo: 'changed' flag for gridDataProvider cache

        var _this = this;

        /**
         * Additional filter: step
         * @type {string}
         */
        var stepFilter;

        /**
         * Additional filter: completed
         * @type {{from: Date, to: Date, enabled: boolean}}
         */
        var completedFilter;

        /**
         * Additional filter: text search
         * @type {{text: string, exact: boolean}}
         */
        var textSearch;

        /**
         * Page number. 1-based
         * @type {number}
         */
        var pageNumber;

        /**
         * Page size
         * @type {number}
         */
        var pageSize;

        /**
         * Main grid filter
         */
        var gridFilter;

        /**
         * Main grid sorting
         */
        var gridSort;

        /**
         * Selected order Item Id
         * @type {string}
         */
        var selectedOrderItemId;

        _.extend(_this, {
            setStepFilter: setStepFilter,
            getStepFilter: getStepFilter,

            setCompletedFilter: setCompletedFilter,
            getCompletedFilter: getCompletedFilter,

            setTextSearch: setTextSearch,
            getTextSearch: getTextSearch,

            setPageNumber: setPageNumber,
            getPageNumber: getPageNumber,

            setPageSize: setPageSize,
            getPageSize: getPageSize,

            setGridFilter: setGridFilter,
            getGridFilter: getGridFilter,

            setGridSort: setGridSort,
            getGridSort: getGridSort,

            setSelectedOrderItemId: setSelectedOrderItemId,
            getSelectedOrderItemId: getSelectedOrderItemId,

            clear: clear,
            isClear: isClear
        });

        return _this;

        function clear() {
            setStepFilter(null);
            setTextSearch(null);
            setCompletedFilter(null);
            setPageNumber(1);
            setGridFilter(null);
            setGridSort(null);
            setSelectedOrderItemId(null);
        }

        /**
         * Check if there was no filters/sorters
         */
        function isClear() {
            return (!completedFilter || !completedFilter.enabled || (!completedFilter.from && !completedFilter.to))
                && (!textSearch || !textSearch.text || textSearch.text.length <= 0)
                && !gridFilter
                && !gridSort;
        }

        //region Getters and setters

        function setStepFilter(_step) {
            if (!_.isEqual(stepFilter, _step)) {
                stepFilter = _.clone(_step);
                _this.setGridFilter(null);
                _this.setGridSort(null);
                _this.setPageNumber(1);
            }
        }

        function getStepFilter() {
            return _.clone(stepFilter);
        }

        function setCompletedFilter(_completed) {
            completedFilter = _.clone(_completed);
        }

        function getCompletedFilter() {
            return _.clone(completedFilter);
        }

        function setTextSearch(_text, _exactMatch) {
            textSearch = {
                text: _text,
                exact: _exactMatch
            };
        }

        function getTextSearch() {
            return _.clone(textSearch);
        }

        function setPageNumber(_pageNumber) {
            pageNumber = _pageNumber;
        }

        function getPageNumber() {
            return pageNumber;
        }

        function setPageSize(_pageSize) {
            pageSize = _pageSize;
        }

        function getPageSize() {
            return pageSize;
        }

        function setGridFilter(_gridFiler) {
            gridFilter = _.clone(_gridFiler);
        }

        function getGridFilter() {
            return _.clone(gridFilter);
        }

        function setGridSort(_gridSort) {
            if (_gridSort != null) {
                gridSort = _.clone(_gridSort);
            } else {
                gridSort = [{ field: "$model.created", dir: "desc" }];
            }
        }

        function getGridSort() {
            return _.clone(gridSort);
        }

        function setSelectedOrderItemId(id) {
            if (!_.isEqual(selectedOrderItemId, id)) {
                selectedOrderItemId = id;
            }
        }

        function getSelectedOrderItemId() {
            return selectedOrderItemId;
        }

        //endregion
    })

;